import React, { useState, useEffect } from 'react'
import {
  Grid,
  MenuList,
  MenuItem,
  Typography,
  Container,
  Link,
} from '@mui/material'
import logo from '../Asset/images/mcash-logo.png'
import axios from 'axios'
import config from '../config'
import HomeIcon from '@mui/icons-material/Home'
import BarChartIcon from '@mui/icons-material/BarChart'
import GridViewIcon from '@mui/icons-material/GridView'
import RoofingIcon from '@mui/icons-material/Roofing'
import FlagIcon from '@mui/icons-material/Flag'
import LockIcon from '@mui/icons-material/Lock'
import FeedIcon from '@mui/icons-material/Feed'
import CallIcon from '@mui/icons-material/Call'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'

export default function Footer() {
  const [categoryList, setCategoryList] = useState([])
  useEffect(() => {
    axios
      .get(`${config.url}/product_categories?offset=0&limit=6`, config.token)
      .then((res) => {
        setCategoryList(res.data.data)
      })
  }, [])

  return (
    <Container maxWidth='xl' sx={{ pt: '50px', color: '#5a5a56' }}>
      <Grid container spacing={2}>
        <Grid item xs={1} />
        <Grid item xs={10} container>
          <Grid item lg={4} sx={{ mt: '-20px' }}>
            <img
              src={logo}
              alt='Mcash logo'
              style={{ width: '175px', paddingBottom: '15px' }}
            />
            <Typography variant='body2'>
              PT M Cash Intergrasi Tbk <br />
              <br />
              Kota Mangkuluhur, lantai 7 <br />
              Jalan Jendral Gatot Subroto Kav.
              <br />
              1-3, Karet Semanggi <br />
              Daerah Khusus Ibukota Jakarta 12930 <br />
              <br /> E: partnership@mcash.id
            </Typography>
          </Grid>
          <Grid item lg={8} container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
              <Typography sx={{ fontWeight: 'bold' }}>Explore</Typography>
              <MenuList>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <HomeIcon sx={{ pr: '15px' }} />
                  <Link href='/' underline='none' sx={{ color: '#000' }}>
                    Home
                  </Link>
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <BarChartIcon sx={{ pr: '15px' }} />
                  <Link
                    href='/top-chart'
                    underline='none'
                    sx={{ color: '#000' }}
                  >
                    Top Chart
                  </Link>
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <GridViewIcon sx={{ pr: '15px' }} />
                  <Link
                    href='/categories'
                    underline='none'
                    sx={{ color: '#000' }}
                  >
                    Categories
                  </Link>
                </MenuItem>
              </MenuList>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Typography sx={{ fontWeight: 'bold' }}>About</Typography>
              <MenuList>
                <Link
                  href='https://www.mcash.id/company-brief-history'
                  target='_blank'
                  underline='none'
                  sx={{ color: '#5a5a56' }}
                >
                  <MenuItem
                    sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                  >
                    <RoofingIcon sx={{ pr: '15px' }} /> Company Brief History
                  </MenuItem>
                </Link>
                <Link
                  href='https://www.mcash.id/vision-and-mission'
                  target='_blank'
                  underline='none'
                  sx={{ color: '#5a5a56' }}
                >
                  <MenuItem
                    sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                  >
                    <FlagIcon sx={{ pr: '15px' }} />
                    Vision & Mission
                  </MenuItem>
                </Link>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <PrivacyTipIcon sx={{ pr: '15px' }} />
                  Certification
                </MenuItem>
              </MenuList>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Typography sx={{ fontWeight: 'bold' }}>Legal</Typography>
              <MenuList>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <LockIcon sx={{ pr: '15px' }} />
                  Privacy Policy
                </MenuItem>
                <MenuItem
                  sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                >
                  <FeedIcon sx={{ pr: '15px' }} />
                  Term of Service
                </MenuItem>
                <Link
                  href='https://www.mcash.id/contact'
                  target='_blank'
                  underline='none'
                  sx={{ color: '#5a5a56' }}
                >
                  <MenuItem
                    sx={{ borderBottom: '1px solid #ddd', pl: 0, fontSize: 14 }}
                  >
                    <CallIcon sx={{ pr: '15px' }} />
                    Contact Us
                  </MenuItem>
                </Link>
              </MenuList>
            </Grid>
            <Grid
              item
              xs={6}
              md={4}
              lg={12}
              sx={{
                display: {
                  xs: 'none',
                  lg: 'block',
                },
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }}>Categories</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={12}
              container
              spacing={2}
              sx={{
                display: {
                  xs: 'none',
                  lg: 'flex',
                },
              }}
            >
              {categoryList?.map((data, idx) => (
                <Grid item xs={12} lg={4} key={idx} sx={{ pt: '0 !important' }}>
                  <MenuList sx={{ pt: '0 !important' }}>
                    <Link
                      href={`/category/${data.id}`}
                      underline='none'
                      sx={{ color: '#000' }}
                    >
                      <MenuItem
                        sx={{
                          borderBottom: '1px solid #ddd',
                          pl: '15px',
                          fontSize: 14,
                        }}
                      >
                        {data.name}
                      </MenuItem>
                    </Link>
                  </MenuList>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </Container>
  )
}
